import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import VeeValidate, { Validator } from 'vee-validate'
// import './registerServiceWorker'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Notifications from 'vue-notification'
import VueI18n from 'vue-i18n'
import { translations } from '@/translations/translation_me'
import vvlocale from 'vee-validate/dist/locale/en';

// config
export const globalStore = new Vue({
  data: {
    // API_BASE_URL: 'http://localhost:8000/',
    API_BASE_URL: 'https://amica-group.bg/5yearwarranty/api/public/index.php/',
    IMPLEMENTATION_ID: 9,
    IMPLEMENTATION_COMPANY: "hansa" // "amica", "hansa"
  }
})

// axios configuration
Axios.defaults.headers.common['Implementation-Id'] = globalStore.IMPLEMENTATION_ID

vvlocale.messages.required = 'Polje je obavezno'
vvlocale.messages.regex = 'Format polja nije važeći'
vvlocale.messages.min = 'Serijski broj mora sadržati najmanje 14 cifara'

Validator.localize({ en: vvlocale })
const vvconfig = {
  locale: 'en'
}

Vue.config.productionTip = false
Vue.use(VeeValidate, vvconfig)
Vue.use(VueAxios, Axios)
Vue.component('icon', Icon)
Vue.use(Notifications)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'me',
  messages: translations
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
